import { FormProvider, useForm } from "react-hook-form";
import { Box, Container, Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { Email, Loading, Poruka } from "../../components";
import axios from "axios";
import { TIP_INFO_PORUKE } from "../../enums";

interface FormValues {
  emailAdresa: string;
  infoPoruka: string;
  successPoruka: string;
  tipInfoPoruke: number | null;
  loading: boolean;
}

const defaultValues = {
  emailAdresa: "",
};

const Index = () => {
  const methods = useForm<FormValues>({ defaultValues });
  const successPoruka = methods.watch("successPoruka");

  const onSubmit = async (data: FormValues) => {
    try {
      methods.setValue("loading", true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/zahtjevi/predforma`,
        data
      );

      if (response.status === 200) {
        methods.setValue("infoPoruka", response.data.message);
        methods.setValue("tipInfoPoruke", TIP_INFO_PORUKE.SUCCESS);
      }
    } catch (error: any) {
      const { status } = error.response;
      if (status === 400) {
        if (error.response.data.errors) {
          error.response.data.errors.forEach((error: any) =>
            methods.setError(error.fieldName, { message: error.error })
          );
          return;
        }
      }

      if (status === 404) {
        if (error.response.data.message) {
          methods.setValue("infoPoruka", error.response.data.message);
          methods.setValue("tipInfoPoruke", TIP_INFO_PORUKE.ERROR);
        }
      }
    } finally {
      methods.setValue("loading", false);
    }
  };

  const onDialogClose = () => {
    if (methods.getValues("tipInfoPoruke") === TIP_INFO_PORUKE.SUCCESS) {
      methods.setValue(
        "successPoruka",
        "Uspješno ste predali podatke za registraciju u DAC7 sustav. Možete zatvoriti karticu. (You have successfully submitted your registration information to the DAC7 system. You can close the tab.)"
      );
    }
  };

  if (successPoruka)
    return (
      <Box>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: 330,
                  margin: "90px auto 0  auto",
                  textAlign: "center",
                }}
              >
                <p>{successPoruka}</p>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );

  return (
    <FormProvider {...methods}>
      <Box>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                component={"form"}
                onSubmit={(e) => {
                  methods.clearErrors();
                  methods.handleSubmit(onSubmit)(e);
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: 330,
                    margin: "90px auto 0  auto",
                  }}
                >
                  <Typography component="h1" variant="h5">
                    Registracija operatera
                  </Typography>
                  <p>
                    Molimo unesite adresu e-pošte na koju ćete dobiti upute za
                    daljnji proces registracije.
                  </p>
                  <Email />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    Potvrdi (Submit)
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Loading />
      <Poruka onClose={onDialogClose} />
    </FormProvider>
  );
};

export default Index;
